import { LOCALE_MAP } from '/src/config';

export default function (configuration) {
    return LOCALE_MAP[configuration.locale] || 'ru-RU';
}
